import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateShoppableProductAndProductMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateShoppableProductAndProductInput;
}>;


export type UpdateShoppableProductAndProductMutation = { __typename?: 'RootMutationType', updateShoppableProductAndProduct?: { __typename?: 'ShoppableProductMutationResult', shoppableProduct?: { __typename?: 'ShoppableProduct', id: string, ctaType: Types.ShoppableProductCtaType, customCtaText?: string | null, product: { __typename?: 'Product', id: string, currencyCode: string, onlineStoreUrl: string, sourceType?: string | null, sourceId?: string | null, title: string, images?: Array<{ __typename?: 'ProductImage', id: string, src?: string | null }> | null, variants?: Array<{ __typename?: 'ProductVariant', id: string, originalPrice?: number | null, price?: number | null }> | null } } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const UpdateShoppableProductAndProductDocument = gql`
    mutation updateShoppableProductAndProduct($id: ID!, $input: UpdateShoppableProductAndProductInput!) {
  updateShoppableProductAndProduct(id: $id, input: $input) {
    shoppableProduct {
      id
      ctaType
      customCtaText
      product {
        id
        currencyCode
        onlineStoreUrl
        sourceType
        sourceId
        title
        images {
          id
          src
        }
        variants {
          id
          originalPrice
          price
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type UpdateShoppableProductAndProductMutationFn = Apollo.MutationFunction<UpdateShoppableProductAndProductMutation, UpdateShoppableProductAndProductMutationVariables>;

/**
 * __useUpdateShoppableProductAndProductMutation__
 *
 * To run a mutation, you first call `useUpdateShoppableProductAndProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShoppableProductAndProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShoppableProductAndProductMutation, { data, loading, error }] = useUpdateShoppableProductAndProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShoppableProductAndProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShoppableProductAndProductMutation, UpdateShoppableProductAndProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShoppableProductAndProductMutation, UpdateShoppableProductAndProductMutationVariables>(UpdateShoppableProductAndProductDocument, options);
      }
export type UpdateShoppableProductAndProductMutationHookResult = ReturnType<typeof useUpdateShoppableProductAndProductMutation>;
export type UpdateShoppableProductAndProductMutationResult = Apollo.MutationResult<UpdateShoppableProductAndProductMutation>;
export type UpdateShoppableProductAndProductMutationOptions = Apollo.BaseMutationOptions<UpdateShoppableProductAndProductMutation, UpdateShoppableProductAndProductMutationVariables>;